module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/verbytska-art-avatar-8fafbf2f47c7a93ef42c708016fc89f5.jpg";